import React from "react";
import classNames from "classnames";

import "./Loader.css";

export default function Loader(props) {
	return <div className={classNames("b-loader", props.className)} />;
}
